/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Audit_Description1Inputs */

const en_coinvestments_audit_description1 = /** @type {(inputs: Coinvestments_Audit_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View events`)
};

/**
* | output |
* | --- |
* | "View events" |
*
* @param {Coinvestments_Audit_Description1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_audit_description1 = /** @type {((inputs?: Coinvestments_Audit_Description1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Audit_Description1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_audit_description1(inputs)
});
export { coinvestments_audit_description1 as "coInvestments_audit_description" }